import { render, staticRenderFns } from "./PersonaDelete.vue?vue&type=template&id=3b239a2e"
import script from "./PersonaDelete.vue?vue&type=script&lang=js"
export * from "./PersonaDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports